export default "__VITE_ASSET__CywwLyon__"